<template>
  <div class="app-shell">
    <!-- 顶栏 -->
    <header class="topbar">
      <router-link to="/" class="brand">
        <span class="brand-icon">⚡</span>
        <span class="brand-name">ChargeSpot</span>
        <span class="brand-sub">充电站信息</span>
      </router-link>
    </header>

    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html, body, #app {
  height: 100%;
}
body {
  font-family: 'PingFang SC', 'Microsoft YaHei', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  background: #f1f5f9;
}
.app-shell {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.topbar {
  height: 56px;
  flex: none;
  background: #0f172a;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.brand {
  display: flex;
  align-items: baseline;
  gap: 8px;
  text-decoration: none;
  color: inherit;
}
.brand-icon {
  font-size: 20px;
}
.brand-name {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.5px;
}
.brand-sub {
  font-size: 12px;
  color: #94a3b8;
}

/* 内容区（前台/后台共用） */
.content {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 16px 16px 32px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  gap: 8px;
  padding: 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  margin-bottom: 12px;
}
.search {
  flex: 1;
  min-width: 0;
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
}
.search:focus {
  border-color: #2563eb;
}
.btn-add {
  padding: 8px 14px;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.btn-add:hover {
  background: #1d4ed8;
}
.station-list {
  padding: 0;
}
.station-form {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}
.tip {
  text-align: center;
  padding: 48px 0;
  color: #64748b;
  font-size: 14px;
}
.tip.error {
  color: #dc2626;
}
.retry {
  margin-left: 10px;
  padding: 4px 14px;
  border: 1px solid #dc2626;
  background: #fff;
  color: #dc2626;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}

/* 统计卡片条 */
.stats-card {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}
.stat-item {
  flex: 1;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 16px;
}
.stat-item .num {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
}
.stat-item .num.green {
  color: #16a34a;
}
.stat-item .label {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

/* 平板（641px - 1023px） */
@media (max-width: 1023px) {
  .content {
    padding: 14px 14px 28px;
  }
}

/* 手机（<=640px） */
@media (max-width: 640px) {
  .topbar {
    height: 50px;
    padding: 0 12px;
  }
  .brand {
    gap: 6px;
  }
  .brand-icon {
    font-size: 18px;
  }
  .brand-name {
    font-size: 17px;
  }
  .brand-sub {
    display: none;
  }
  .content {
    padding: 10px 10px 24px;
  }
  .toolbar {
    padding: 10px;
  }
  .stats-card {
    gap: 8px;
  }
  .stat-item {
    padding: 10px 12px;
  }
  .stat-item .num {
    font-size: 18px;
  }
}
</style>
